import { Link } from "react-router-dom";
import { Play, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { PhoneMockup } from "./PhoneMockup";
import { siteConfig } from "@/config/siteConfig";

const tilts = [-5, 5, -4, 4];

export const AppSection = () => {
  const { playStoreUrl } = siteConfig.links;
  const shots = siteConfig.appScreenshots;

  return (
    <section id="app" className="border-y border-slate-200 bg-slate-50 py-24 sm:py-32" data-testid="app-section">
      <div className="mx-auto grid max-w-6xl items-center gap-14 px-5 sm:px-8 lg:grid-cols-2">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-slate-500">The app</p>
          <h2 className="mt-4 font-display text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
            ORIVA, in your pocket.
          </h2>
          <p className="mt-5 max-w-md text-base leading-relaxed text-slate-600">
            The full ORIVA experience — Study, Create and Work — as a fast, native
            Android app. Download it, pick your world, and put an AI assistant to work
            on the things that matter to you.
          </p>

          <div className="mt-9 flex flex-wrap items-center gap-4">
            {playStoreUrl ? (
              <a
                href={playStoreUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="play-store-button"
                className="inline-flex items-center gap-3 rounded-full bg-slate-900 px-7 py-3.5 text-sm font-medium text-white transition-colors duration-200 hover:bg-slate-700"
              >
                <Play className="h-4 w-4 fill-current" />
                Get it on Google Play
                <ArrowUpRight className="h-4 w-4" />
              </a>
            ) : (
              <span
                data-testid="play-store-button"
                className="inline-flex cursor-not-allowed items-center gap-3 rounded-full bg-slate-900/80 px-7 py-3.5 text-sm font-medium text-white"
              >
                <Play className="h-4 w-4 fill-current" />
                Google Play — launching soon
              </span>
            )}
            <Link
              to="/contact"
              data-testid="app-notify-link"
              className="text-sm font-medium text-oriva-blue underline-offset-4 transition-colors duration-200 hover:underline"
            >
              Questions? Contact support
            </Link>
          </div>

          <p className="mt-6 font-mono text-xs uppercase tracking-[0.2em] text-slate-400">
            Android · Google Play
          </p>
        </Reveal>

        <div style={{ perspective: "1400px" }}>
          <div
            className={`mx-auto grid max-w-lg gap-5 ${
              shots.length > 1 ? "grid-cols-2" : "max-w-xs grid-cols-1"
            }`}
          >
            {shots.map((shot, i) => (
              <PhoneMockup
                key={`${shot.src}-${i}`}
                src={shot.src}
                alt={shot.alt}
                tilt={tilts[i % tilts.length]}
                delay={i * 0.12}
                className={i % 2 === 1 ? "sm:translate-y-8" : ""}
              />
            ))}
          </div>
          <p className="mt-8 text-center font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400">
            Real screenshots from the ORIVA Android app
          </p>
        </div>
      </div>
    </section>
  );
};
